// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-flat[data-v-47fc3f10]{padding:1em 2em}", "",{"version":3,"sources":["webpack://./resources/js/apps/global-declare-components/ui/components/BlockFlat.vue"],"names":[],"mappings":"AACA,6BACE,eAAF","sourcesContent":["\n.block-flat {\n  padding: 1em 2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
